import type { MtbTrailMetadata } from "~/lib/api";
import { Tag } from "~/components/ui/tag";
import { BUILD_LABELS, CHARACTER_LABELS, FEATURE_LABELS } from "./mtbTrailLabels";

interface MtbTrailStylePillsProps {
  metadata: MtbTrailMetadata;
}

export function MtbTrailStylePills({ metadata }: MtbTrailStylePillsProps) {
  const { character, features, build } = metadata;

  return (
    <div className="flex flex-wrap gap-1.5">
      {character?.map((c) => (
        <Tag key={c}>{CHARACTER_LABELS[c]}</Tag>
      ))}
      {features?.map((f) => (
        <Tag key={f}>{FEATURE_LABELS[f]}</Tag>
      ))}
      {build && <Tag>{BUILD_LABELS[build]}</Tag>}
    </div>
  );
}
